import { createSlice } from '@reduxjs/toolkit';

export const CloneTemplateStruct = {
    Core: {},
    Payload: {},
    Comm: {},
    Power: {},
    Other: {},
};

const initialState = {
    catalogs: null,
    filterPayloadDeviceList: [],
    isPayloadSlider: false,
    payloadSliderData: {},
    isEditPayload: false,
    EditPayloadData: {},
    isEditEdgeData: false,
    EditEdgeData: {},
    Edges: [],
    isEdgeSelected: false,
    CloneTemplate: CloneTemplateStruct,
    Template: {},
    isTemplateSelected: false,
};

const CatalogSlice = createSlice({
    name: 'Catalog',
    initialState,
    reducers: {
        getCatalogRequest: () => {
            // This can be used to set a loading state if needed
        },
        getCatalogSuccess: (state, action) => {
            state.catalogs = action.payload;
        },
        getCatalogFailure: (state) => {
            // This can be used to set an error state if needed
        },
        setFilterPayloadDeviceList: (state, action) => {
            state.filterPayloadDeviceList = action.payload;
        },
        setPayloadSliderTrue: (state) => {
            state.isPayloadSlider = true;
        },
        setPayloadSliderFalse: (state) => {
            state.isPayloadSlider = false;
        },
        setEditPayloadData: (state, action) => {
            state.EditPayloadData = action.payload;
        },
        setEdge: (state, action) => {
            state.Edges = action.payload;
        },
        setEdgeSelected: (state, action) => {
            state.isEdgeSelected = action.payload;
        },
        setTemplate: (state, action) => {
            if (action.payload) {
                state.Template = action.payload;
            } else {
                state.Template = {};
            }
        },
        setShowTemplateSlideToTrue: (state) => {
            state.isTemplateSelected = true;
        },
        setShowTemplateSlideToFalse: (state) => {
            state.isTemplateSelected = false;
        },
        setCloneTemplate: (state, action) => {
            if (action.payload) {
                if (action.payload['All']) {
                    state.CloneTemplate = { ...state.CloneTemplate, ...action.payload['All'] };
                }
                else if (action.payload['Core']) {
                    state.CloneTemplate.Core = { ...state.CloneTemplate.Core, ...action.payload['Core'] };
                }
                else if (action.payload['Payload Server']) {
                    state.CloneTemplate.Payload = { ...state.CloneTemplate.Payload, ...action.payload['Payload Server'] };
                }
                else if (action.payload['Communication']) {
                    state.CloneTemplate.Comm = { ...state.CloneTemplate.Comm, ...action.payload['Communication'] };
                }
                else if (action.payload['Power']) {
                    state.CloneTemplate.Power = { ...state.CloneTemplate.Power, ...action.payload['Power'] };
                } else if (action.payload['Other']) {
                    state.CloneTemplate.Other = action.payload['Other'];
                } else {
                    state.CloneTemplate.Core = {}
                    state.CloneTemplate.Payload = {}
                    state.CloneTemplate.Comm = {}
                    state.CloneTemplate.Power = {}
                    state.CloneTemplate.Other = {}
                }

            } else {
                state.CloneTemplate = {
                    Core: {},
                    Payload: {},
                    Comm: {},
                    Power: {},
                    Other: {},
                };
            }
        },
    },

});

export const {
    getCatalogRequest,
    getCatalogSuccess,
    getCatalogFailure,
    setFilterPayloadDeviceList,
    setPayloadSliderTrue,
    setPayloadSliderFalse,
    setEditPayloadData,
    setEdge,
    setEdgeSelected,
    setTemplate,
    setShowTemplateSlideToTrue,
    setShowTemplateSlideToFalse,
    setCloneTemplate,
} = CatalogSlice.actions;

export default CatalogSlice.reducer;
